import React from 'react';

const EditProfile = React.lazy(() => import('./EditProfile'));

export default EditProfile;

// Modal exports
export { ChangeEmailModal } from './ChangeEmailModal';
export { useOpenChangeEmailModal } from './hooks';
export { EditProfileModals } from './types';
